import { defineComponent as I, toRef as w, computed as y, ref as x, shallowRef as L, onMounted as N, watch as _, openBlock as $, createBlock as M, resolveDynamicComponent as U, normalizeStyle as O, withCtx as P, renderSlot as k, normalizeProps as q, guardReactiveProps as z } from "vue";
const R = "--vc-auto-duration", B = `height var(${R}) cubic-bezier(0.33, 1, 0.68, 1)`, d = { padding: 0 }, V = 300, Y = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
}, K = () => typeof navigator < "u" && navigator.userAgent.includes("Firefox");
function C(n) {
  return n.value ? parseFloat(getComputedStyle(n.value).height) : 0;
}
function D(n) {
  var a;
  return {
    height: `${((a = n.value) == null ? void 0 : a.scrollHeight) || 0}px`
  };
}
function b(n) {
  if (!n.value)
    return {};
  const { transition: a } = getComputedStyle(n.value);
  return a === "all 0s ease 0s" || K() && a === "all" ? { transition: B } : { transition: a };
}
function H(n) {
  if (!n.value)
    return !0;
  const { transition: a } = getComputedStyle(n.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || a.includes("none") || a.includes("height 0s");
}
function j(n = 0) {
  if (n === 0)
    return 0;
  const a = n / 36, i = Math.round((4 + 15 * a ** 0.25 + a / 5) * 10);
  return Number.isFinite(i) ? i : 0;
}
const Q = /* @__PURE__ */ I({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(n, { emit: a }) {
    const i = n, s = a, l = w(i, "when"), o = w(i, "baseHeight"), p = y(() => ({ overflow: "hidden", height: `${o.value}px` })), f = y(() => ({
      ...d,
      ...o.value === 0 ? { display: "none" } : p.value
    })), t = x(null), v = x(l.value ? "expanded" : "collapsed"), c = (e) => v.value = e;
    function F() {
      return l.value ? d : o.value === 0 ? Y : f.value;
    }
    const h = L(F()), r = (e) => h.value = e, u = (e) => r({ ...h.value, ...e }), S = x(V), T = (e) => S.value = e, A = y(() => ({ [R]: `${S.value}ms` }));
    function g() {
      r(d), c("expanded"), s("expanded");
    }
    function m() {
      r(f.value), c("collapsed"), s("collapsed");
    }
    N(() => {
      if (!t.value)
        return;
      const e = j(t.value.scrollHeight - o.value);
      e > 0 && T(e), !l.value && o.value === 0 && r(f.value);
    }), _(l, (e) => {
      if (t.value)
        if (e) {
          if (H(t))
            return g();
          c("expanding"), s("expand"), r({
            ...d,
            ...p.value,
            ...A.value
          }), requestAnimationFrame(() => {
            if (t.value.scrollHeight === 0)
              return g();
            u({
              ...D(t),
              ...b(t),
              willChange: "height"
            });
          });
        } else {
          if (H(t) || (c("collapsing"), s("collapse"), u({
            ...A.value,
            ...D(t)
          }), t.value.scrollHeight === 0))
            return m();
          requestAnimationFrame(() => {
            u({
              ...p.value,
              ...b(t),
              willChange: "height"
            });
          });
        }
    }), _(o, (e) => {
      l.value || (e > 0 ? u({ display: void 0, height: `${e}px` }) : u({ display: "none" }));
    });
    function E(e) {
      e.target && e.target === t.value && e.propertyName === "height" && (l.value ? Math.abs(t.value.scrollHeight - C(t)) < 1 && g() : Math.abs(o.value - C(t)) < 1 && m());
    }
    return (e, G) => ($(), M(U(i.as), {
      ref_key: "collapseRef",
      ref: t,
      style: O(h.value),
      onTransitionend: E,
      "data-collapse": v.value
    }, {
      default: P(() => [
        k(e.$slots, "default", q(z({ state: v.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
});
export {
  Q as Collapse
};
